import React from "react";
import { Separator } from "@commonsku/design-system";
import { isTaskNewlyPosted, TaskListSectionsProps, TaskNote } from "../../../redux/myTasks";
import TaskSection from "./TaskSection";

/** Your Tasks: anything posted since the tab was last seen, split out from the rest. */
const MyTasksSections = ({ tab, notes, seenAt, onToggleComplete }: TaskListSectionsProps) => {
  const newlyPosted: TaskNote[] = [];
  const rest: TaskNote[] = [];
  notes.forEach((note) => {
    (isTaskNewlyPosted(note, seenAt) ? newlyPosted : rest).push(note);
  });

  return (
    <>
      <TaskSection heading="Newly Posted" tab={tab} notes={newlyPosted} onToggleComplete={onToggleComplete} />
      {newlyPosted.length > 0 && rest.length > 0 && <Separator marginY="1" />}
      <TaskSection tab={tab} notes={rest} onToggleComplete={onToggleComplete} />
    </>
  );
};

export default MyTasksSections;
